import { WarrantSharedService } from '../../services/wealthlane-captable-services';
import { type UseQueryResult, useQuery } from 'react-query';

const useGetWarrantSettlementTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  enabled: boolean = true
): UseQueryResult<any[] | undefined, unknown> => {
  return useQuery(
    ['getWarrantSettlementTypes'],
    async () => {
      const result = await handleRequest(
        WarrantSharedService.getApiCapTableApiAppWarrantSharedWarrantSettlementTypes()
      );
      return result ?? [];
    },
    {
      enabled,
      select: (data) => {
        return (data ?? []).map((item: any) => ({
          label: item.displayName ?? '',
          value: item.id ?? '',
        }));
      },
    }
  );
};

export default useGetWarrantSettlementTypes;
